const BASE_URL = process.env.REACT_APP_SANDBOX_HTTP_BASE_URL;
const EPICENTER_BASE_URL =
  process.env.REACT_APP_EPICENTER_HTTP_BASE_URL ||
  process.env.REACT_APP_EPICENTERAPI_BASE_URL;
const STUDENT_PORTAL_BASE_URL = process.env.REACT_APP_STUDENT_PORTAL_BASE_URL;
const CY_SSO_BASE_URL = process.env.REACT_APP_SSO_BASE_URL;

export {
  BASE_URL,
  EPICENTER_BASE_URL,
  STUDENT_PORTAL_BASE_URL,
  CY_SSO_BASE_URL,
};
